<div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select
        [class.ng-select-fill]="!tableStyle"
        [formControl]="fc"
        [placeholder]="field.name"
        [items]="customers"
        [trackByFn]="trackByFn"
        [loading]="customersLoading"
        [typeahead]="customerInput$"
        (focus)="customerFocus$.next()"
        bindValue="afas_customer_id"
        appendTo="body">
        <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
            {{ item.name }}
        </ng-template>
    </ng-select>
    @if (!fc.value || !(customers | byId: fc.value : 'afas_customer_id')) {
        <mat-hint>{{ formData?.orginal?.contractor }}</mat-hint>
    }
    <mat-error [control]="fc"></mat-error>
</div>
